<mat-form-field
  class="lib-input coin-form-field-outline coin-form-field-outline--{{ matFormFieldClass }} no-margin"
  matTooltipClass="error-tooltip"
  appearance="outline"
  floatLabel="always"
  [matTooltip]="errorTooltip()"
  [matTooltipDisabled]="!touched()">
  @if (label) {
    <mat-label>
      {{ label }}
      @if (isRequired) {
        *
      }
    </mat-label>
  }
  <mat-select
    #matSelect="matSelect"
    [panelClass]="panelHeightClass()"
    [panelWidth]="hiddenForm ? null : 'auto'"
    [placeholder]="placeholder"
    [multiple]="multiple"
    [disabled]="disabled()"
    [compareWith]="compareWith"
    [(ngModel)]="value"
    (closed)="onTouch()"
    (openedChange)="onOpenedChange($event)">
    <!--Custom Trigger -->
    <mat-select-trigger>
      @switch (selectTriggerType) {
        @case ('template') {
          <ng-container *ngTemplateOutlet="selectedValueTemplate()"></ng-container>
        }
        @case ('multiple-values') {
          <p>
            <i>
              {{ 'general.dropdown-selected' | translate }}
              <b>{{ $any(value).length }}</b>
            </i>
          </p>
        }
        @default {
          {{ matSelect.triggerValue || ('general.unknown-value' | translate) }}
        }
      }
    </mat-select-trigger>

    @if (topTemplate()) {
      <div class="top-container">
        <ng-container *ngTemplateOutlet="topTemplate()"></ng-container>
      </div>
    }

    <!--Search Input -->
    @if (search.observed) {
      <div class="filter-container">
        <coin-v2-text-input
          [loading]="loading"
          [label]="'general.dropdown-search-label' | translate"
          [formControl]="searchControl"
          [inputDebounce]="searchDebounce"
          [clearable]="true"
          (keydown)="$event.stopPropagation()"></coin-v2-text-input>
      </div>
      <!-- Enables search opening with no available options -->
      @if (!options()?.length) {
        <mat-option hidden></mat-option>
      }
    }

    <!--Dropdown Options -->
    @if (!isRequired && !multiple) {
      <mat-option [value]="null">---</mat-option>
    }
    @for (option of options(); track option) {
      <mat-option
        [value]="option.value"
        [disabled]="option.disabled">
        <ng-container *ngTemplateOutlet="option.template"></ng-container>
      </mat-option>
    }

    <!-- Temporary Workaround: provide already selected values as options so that they don't deselect when gone -->
    @if (multiple) {
      @for (item of $any(value); track item) {
        <mat-option
          hidden
          [value]="item"></mat-option>
      }
    }

    @if (bottomTemplate()) {
      <div class="bottom-container">
        <ng-container *ngTemplateOutlet="bottomTemplate()"></ng-container>
      </div>
    }
  </mat-select>
</mat-form-field>
